import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import React from "react";
import Button from "../../../ui/elements/buttons/Button";
import currencyCodes from "currency-codes";
import "currency-flags/dist/currency-flags.min.css";
import { Currency } from "../settingsType/Currency";

type Props = {
  open: boolean;
  handleClose: () => void;
  isEditing: boolean;
  currentCurrency: Currency | undefined;
  handleSelectChange: (e: SelectChangeEvent<string>) => void;
  handleFactorChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSave: () => void;
  isValidCurrency: () => boolean | "" | 0 | undefined;
  currencyData: Currency[];
  isSaving: boolean;
};

const AddEditpopup = ({
  open,
  handleClose,
  isEditing,
  currentCurrency,
  handleSelectChange,
  handleFactorChange,
  handleSave,
  isValidCurrency,
  currencyData,
  isSaving,
}: Props) => {
  // console.log("currency", currentCurrency);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {isEditing ? "Edit Currency" : "Add New Currency"}
      </DialogTitle>
      <DialogContent sx={{ display: "flex", gap: "8px" }}>
        <FormControl
          fullWidth
          margin="dense"
          sx={{
            "& .MuiInputLabel-root": { color: "black" },
            minWidth: "250px",
          }}
        >
          <InputLabel shrink>Currency</InputLabel>
          <Select
            value={currentCurrency?.name || ""}
            onChange={handleSelectChange}
            label="Currency"
            displayEmpty
            MenuProps={{
              PaperProps: {
                sx: {
                  width: "300px",
                  maxHeight: "380px",
                  overflowY: "auto",
                },
              },
            }}
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            {currencyCodes.data
              .filter(
                (currency) =>
                  !currencyData.some(
                    (existing) => existing.code === currency.code
                  ) || currentCurrency?.code === currency.code
              )
              .map((currency) => (
                <MenuItem key={currency.code} value={currency.currency}>
  <Box
    display="flex"
    alignItems="center"
    sx={{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "100%",
    }}
  >
    <span
      className={`currency-flag currency-flag-${currency.code.toLowerCase()}`}
      style={{
        marginRight: "10px",
        width: "24px",
        height: "18px",
        flexShrink: 0,
      }}
    ></span>
    <Box
      component="span"
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        display: "inline-block",
      }}
    >
      {currency.currency}
    </Box>
  </Box>
</MenuItem>

              ))}
          </Select>
        </FormControl>

        <TextField
          margin="dense"
          label="Currency Code"
          name="code"
          placeholder="Select"
          value={currentCurrency?.code || ""}
          fullWidth
          InputLabelProps={{ shrink: true }}
          sx={{ "& .MuiInputLabel-root": { color: "black" } }}
        />

        <TextField
          margin="dense"
          label="Factor"
          name="factor"
          type="number"
          placeholder="Select"
          value={currentCurrency?.factor ?? ""}
          onChange={handleFactorChange}
          fullWidth
          inputProps={{
            min: 0, // prevents negative values via arrow buttons or manual typing
            step: "any", // allows decimals like 0.1, 0.01, etc.
          }}
          InputLabelProps={{ shrink: true }}
          sx={{ "& .MuiInputLabel-root": { color: "black" } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} background={"#fff"} color={"#000"}>
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          color="#fff"
          background={"#F6333F"}
          disabled={isSaving || !isValidCurrency()}
        >
          {isEditing ? "Save" : "Add Currency"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddEditpopup;
